import * as React from "react";
import { connect } from "react-redux";
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import PassForm from "../components/BuscadorReportes.js";
import password from "../assets/password.png";
import { Creators } from "../store/ducks/users.js";
import Header from "../components/Header.js";
import { styles } from "../theme/styles.js";

function MenuAppBar(props) {
  const { redirectToPasswordScreen } = props;

  return (
    <div style={styles.content}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={styles.passg}>
        <PassForm />
      </Grid>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    redirectToPasswordScreen: state.users.redirectToPasswordScreen,
  };
};

const creators = {
  logout: Creators.logout,
};

export default connect(mapStateToProps, creators)(MenuAppBar);
